"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _form = _interopRequireDefault(require("./form"));

var _field = _interopRequireDefault(require("../fields/field"));

var _formField = _interopRequireDefault(require("../fields/form-field"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// e.g.
// access: {
//   form: {
//     create: 'role2',
//     read: [ 'role1', 'role2' ],
//     update: [ 'role1', 'role2' ],
//     archive: 'role2'
//   },
//
//   fields: {
//     firstName: {
//       create: 'role2',
//       read: [ 'role1', 'role2' ],
//       update: 'role2',
//       archive: 'role2'
//     }
//   }
// }
var AccessRolesField = /*#__PURE__*/function (_Field) {
  (0, _inherits2.default)(AccessRolesField, _Field);

  var _super = _createSuper(AccessRolesField);

  function AccessRolesField() {
    var _this;

    (0, _classCallCheck2.default)(this, AccessRolesField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'AccessRolesField');
    return _this;
  }

  (0, _createClass2.default)(AccessRolesField, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(AccessRolesField.prototype), "_create", this).call(this, Object.assign({}, props, {
        allowScalar: true
      }));
    }
  }]);
  return AccessRolesField;
}(_field.default);

var AccessNode = /*#__PURE__*/function (_Form) {
  (0, _inherits2.default)(AccessNode, _Form);

  var _super2 = _createSuper(AccessNode);

  function AccessNode() {
    var _this2;

    (0, _classCallCheck2.default)(this, AccessNode);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_className", 'AccessNode');
    return _this2;
  }

  (0, _createClass2.default)(AccessNode, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(AccessNode.prototype), "_create", this).call(this, props);
      this.addField(new AccessRolesField({
        name: 'create',
        label: 'Create'
      }));
      this.addField(new AccessRolesField({
        name: 'read',
        label: 'Create'
      }));
      this.addField(new AccessRolesField({
        name: 'update',
        label: 'Create'
      }));
      this.addField(new AccessRolesField({
        name: 'archive',
        label: 'Create'
      }));
    }
  }]);
  return AccessNode;
}(_form.default);

var AccessFields = /*#__PURE__*/function (_Form2) {
  (0, _inherits2.default)(AccessFields, _Form2);

  var _super3 = _createSuper(AccessFields);

  function AccessFields() {
    var _this3;

    (0, _classCallCheck2.default)(this, AccessFields);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "_className", 'AccessFields');
    return _this3;
  }

  (0, _createClass2.default)(AccessFields, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(AccessFields.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            name: 'fieldNames',
            component: 'Field' // TODO: properly define

          }]
        }
      });
    }
  }, {
    key: "set",
    value: function set(props) {
      var _this4 = this;

      (0, _get2.default)((0, _getPrototypeOf2.default)(AccessFields.prototype), "set", this).call(this, props);

      if (props.fieldNames !== undefined) {
        this.removeFieldsExcept();
        props.fieldNames.forEach(function (fieldName) {
          _this4.addField(new _formField.default({
            name: fieldName,
            form: new AccessNode()
          }));
        });
      }
    }
  }]);
  return AccessFields;
}(_form.default);

var FormAccess = /*#__PURE__*/function (_Form3) {
  (0, _inherits2.default)(FormAccess, _Form3);

  var _super4 = _createSuper(FormAccess);

  function FormAccess() {
    var _this5;

    (0, _classCallCheck2.default)(this, FormAccess);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this5 = _super4.call.apply(_super4, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this5), "_className", 'FormAccess');
    return _this5;
  }

  (0, _createClass2.default)(FormAccess, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(FormAccess.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            name: 'fieldNames',
            component: 'Field' // TODO: properly define

          }]
        }
      });
      this.addField(new _formField.default({
        name: 'form',
        label: 'Form',
        form: new AccessNode()
      }));
      this.addField(new _formField.default({
        name: 'fields',
        label: 'Fields',
        form: new AccessFields()
      }));
    }
  }, {
    key: "set",
    value: function set(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(FormAccess.prototype), "set", this).call(this, props);

      if (props.fieldNames !== undefined) {
        this.getField('fields').getForm().set({
          fieldNames: props.fieldNames
        });
      }
    }
  }]);
  return FormAccess;
}(_form.default);

exports.default = FormAccess;